import React from 'react'
import resources from '../../../services'
import DataTable from '../../../composents/DataTable'
import MainPage from '../../../composents/MainPage'
import { renderStatus, renderStyle } from '../../DashBoard'

const title = 'Transaction'
const headers = {
  icon: 'feather icon-droplet',
  title: title,
  description: 'track all transaction information',
}

export default function TransactionPage() {
  return (
    <MainPage headers={headers} show_search>
      <DataTable
        column={[
          {
            label: 'Emit',
            field: 'status',
            renderStyle: (e) => {
              return e.user?.surname
            },
          },
          { label: 'Quantity', field: 'quantity' },
          {
            label: 'Amount',
            field: 'amount',
          },

          {
            label: 'Type',
            field: 'status',
            renderStyle: (data) => {
              return renderStyle(data)
            },
          },
          {
            label: 'Receive',
            field: 'status',
            renderStyle: (e) => {
              return e?.person?.surname || ''
            },
          },
          {
            label: 'Status',
            field: 'status',
            renderStyle: (data) => {
              return renderStatus(data)
            },
          },
        ]}
        resource={resources.transaction}
        title={title}
        show_btn={false}
        deleteItem={false}
        update={false}
        link="/hydrowallet/water_market"
      />
    </MainPage>
  )
}
